import { render, staticRenderFns } from "./logwood-history-inventory.vue?vue&type=template&id=7cd8323f&scoped=true&"
import script from "./logwood-history-inventory.vue?vue&type=script&lang=ts&"
export * from "./logwood-history-inventory.vue?vue&type=script&lang=ts&"
import style0 from "./logwood-history-inventory.vue?vue&type=style&index=0&id=7cd8323f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd8323f",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cd8323f')) {
      api.createRecord('7cd8323f', component.options)
    } else {
      api.reload('7cd8323f', component.options)
    }
    module.hot.accept("./logwood-history-inventory.vue?vue&type=template&id=7cd8323f&scoped=true&", function () {
      api.rerender('7cd8323f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/logwood/views/logwood-history-inventory.vue"
export default component.exports